<!-- Spec: .github/specs/361623-global-banners-fe.md (NAV-1–NAV-8) -->
<section
  class="banner-container"
  *ngIf="activeBanner && !areaDismissed"
  [ngClass]="getBannerTypeClass(activeBanner.type__c)"
  [class.banner-collapsed]="isCollapsed"
  aria-label="Banner notifications"
  [attr.aria-busy]="loading"
>
  <div class="banner-controls">
    <div
      *ngIf="!isCollapsed"
      class="banner-types"
      role="group"
      aria-label="Select banner type"
    >
      <button
        *ngFor="let group of groups; trackBy: trackByGroupType"
        type="button"
        class="banner-type"
        [ngClass]="getBannerTypeClass(group.type)"
        [attr.data-banner-type]="group.type"
        [attr.aria-pressed]="group.type === activeBanner.type__c"
        [attr.aria-label]="
          group.type + ': ' + group.banners.length + ' banners'
        "
        [attr.title]="group.type"
        (click)="selectType(group.type)"
      >
        <span class="banner-icon" aria-hidden="true"></span>
        <span class="banner-type-name">{{ group.type }}</span>
        <span>{{ group.banners.length }}</span>
      </button>
      <span class="banner-position"
        >{{ "lbl_type" | content }}: {{ typePosition }} /
        {{ activeGroup?.banners?.length }}</span
      >
    </div>
    <div
      class="banner-navigation"
      role="group"
      aria-label="Navigate banner notifications"
    >
      <span *ngIf="!isCollapsed" class="banner-position"
        >All: {{ activeIndex + 1 }} / {{ availableBanners.length }}</span
      >
      <button
        *ngIf="!isCollapsed"
        type="button"
        class="banner-nav"
        aria-label="Previous banner (wraps to last)"
        [disabled]="availableBanners.length < 2"
        (click)="navigate(-1)"
      >
        <span aria-hidden="true">◀</span>
      </button>
      <button
        *ngIf="!isCollapsed"
        type="button"
        class="banner-nav"
        aria-label="Next banner (wraps to first)"
        [disabled]="availableBanners.length < 2"
        (click)="navigate(1)"
      >
        <span aria-hidden="true">▶</span>
      </button>
      <button
        type="button"
        class="banner-toggle"
        [attr.aria-label]="isCollapsed ? 'Expand banner' : 'Collapse banner'"
        [attr.aria-expanded]="!isCollapsed"
        (click)="toggleCollapsed()"
      >
        <span aria-hidden="true">{{ isCollapsed ? "+" : "−" }}</span>
      </button>
    </div>
  </div>
  <div
    *ngIf="!isCollapsed"
    id="banner-message"
    class="banner-message"
    tabindex="0"
    role="region"
    aria-label="Current banner message"
  >
    <p class="banner-text">{{ activeBanner.content__c }}</p>
  </div>
  <span
    *ngIf="!isCollapsed"
    class="sr-only"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    {{ activeBanner.type__c }} banner {{ typePosition }} of
    {{ activeGroup?.banners?.length }}. Banner {{ activeIndex + 1 }} of
    {{ availableBanners.length }} overall.
  </span>
</section>
